// src/components/audition-booking-wizard/WizardStepper.jsx
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { WIZARD_STEPS } from './utils/bookingHelpers'; // Use dynamic steps

const WizardStepper = ({ currentStep, selectedMode, handleStepClick }) => {
    const steps = WIZARD_STEPS(selectedMode);
    return (
        <div className="wizard-stepper-container">
            {steps.map((label, i) => (
                <div 
                    key={i} 
                    className={`step-item ${currentStep > i ? 'active' : ''}`}
                    onClick={() => handleStepClick(i)}
                    style={{ cursor: (i + 1 < currentStep) ? 'pointer' : 'default' }} // Only allow clicking completed steps or current
                >
                    <div className="step-circle">{i + 1}</div>
                    <div className="step-label">{label}</div>
                </div>
            ))}
        </div>
    );
};

export default WizardStepper;